<div class="modal-header">
	<h4 class="modal-title fw-bold">
		<span jhiTranslate="germplasm-list-add.header"></span>
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
			(click)="closeModal()" [disabled]="isLoading"></button>
</div>
<div class="modal-body" data-test="addToListModalBody">
	<div class="row mb-3">
		<div class="col-xs-12 col-md-12">
			<div class="table-responsive custom-scroll-style" style="max-height: 800px; overflow-y: auto;">
				<p-treeTable [value]="nodes"
							 (onNodeExpand)="onNodeExpand($event)"
							 selectionMode="single"
							 [autoLayout]="true"
							 [(selection)]="selectedNode"
							 (onNodeSelect)="onNodeSelect($event)"
							 styleClass="tree-table"
							 data-test="addToListTable">
					<ng-template pTemplate="header">
						<tr>
							<th jhiTranslate="germplasm-list-add.column.name">Name</th>
							<th jhiTranslate="germplasm-list-add.column.owner">Owner</th>
							<th jhiTranslate="germplasm-list-add.column.description">Description</th>
							<th jhiTranslate="germplasm-list-add.column.type">Type</th>
							<th jhiTranslate="germplasm-list-add.column.no.of.entries"># of entries</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-i="rowIndex">
						<tr [ttSelectableRow]="rowNode">
							<td>
								<p-treeTableToggler
									[rowNode]="rowNode"
								></p-treeTableToggler>
								<span [ngClass]="{ 'folder': !rowNode.node.leaf, 'file': rowNode.node.leaf }"></span>
                                {{translateName(rowData)}}
							</td>
							<td>{{rowData.owner}}</td>
                            <td><truncate-span [textInput]="rowData.description"></truncate-span></td>
							<td>{{rowData.type}}</td>
							<td>{{rowData.noOfEntries}}</td>
						</tr>
					</ng-template>
				</p-treeTable>
			</div>
		</div>
	</div>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeModal()" [disabled]="isLoading">
		<span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="cancel" data-test="addToListCancelButton"></span>
	</button>
	<button (click)="validate()" [disabled]="isLoading" class="btn btn-primary">
		<span *ngIf="isLoading" class="throbber throbber-btn"></span>
		<span class="fa fa-plus"></span>&nbsp;<span jhiTranslate="germplasm-list-add.add-action" data-test="addToListModalButton"></span>
	</button>
</div>
